export default __webpack_public_path__ + "static/media/icon_message.03de6264.svg";